<template>
  <div>
    <!-- 使用 el-tabs 的 v-model 来控制当前激活的 Tab -->
    <p style="font-size: 14px; margin-left: 10px">估值计算时间：{{ formattedTime }}</p>
    <el-tabs v-model="currentTab" tab-class="custom-tabs" class="full-width-tabs">
      <!-- 直接使用 label 作为显示的标签 -->
      <!--      <el-tab-pane label="用户管理" name="UserManagement">-->
      <!--        &lt;!&ndash; 使用 <router-view> 来显示对应的路由组件 &ndash;&gt;-->
      <!--      </el-tab-pane>-->
      <!--      <el-tab-pane label="配置管理" name="ConfigManagement">-->
      <!--        &lt;!&ndash; 使用 <router-view> 来显示对应的路由组件 &ndash;&gt;-->
      <!--      </el-tab-pane>-->
      <!--      <el-tab-pane label="白银" name="Baiyin">-->
      <!--      </el-tab-pane>-->
      <el-tab-pane
          label="指数基"
          name="fundZhiShu"
      >
      </el-tab-pane>

      <el-tab-pane
          label="我的收藏"
          name="fundStabe"
      >
      </el-tab-pane>
<!--      <el-tab-pane label="股票基" name="fundGuPiao">-->
<!--      </el-tab-pane>-->

<!--      <el-tab-pane-->
<!--          label="Qdii"-->
<!--          name="fundQdii"-->
<!--      >-->
<!--      </el-tab-pane>-->

<!--      <el-tab-pane-->
<!--          label="套利汇总"-->
<!--          name="fundTaoli"-->
<!--      >-->
<!--      </el-tab-pane>-->

      <el-tab-pane
          label="我的收藏test"
          name="fundList1"
      >
      </el-tab-pane>
    </el-tabs>

    <component :is="currentTabComponent"></component>
  </div>
</template>

<script setup>
import {provide, reactive, computed, ref, watch} from 'vue';
import fundZhiShu from "@/components/fund/FunZhishu.vue";
import fundGuPiao from "@/components/fund/FundGuPiao.vue";
import fundTaoli from "@/components/fund/FundTaoli.vue";
import fundList1 from "@/components/fund/FundList1.vue";
import fundQdii from "@/components/fund/FundQdii.vue";
import fundStabe from "@/components/fund/FundStabe.vue";

// 定义当前标签
const currentTab = ref('fundZhiShu'); // 使用 ref 定义一个字符串类型的响应式变量

// 定义共享数据
const sharedData = reactive({
  message: 'Hello from Grandparent',
  updateMessage: (newMessage) => {
    sharedData.message = newMessage;
  },
});

// 提供数据
provide('sharedData', sharedData);

// 动态组件
const currentTabComponent = computed(() => {
  switch (currentTab.value) {
    case 'fundZhiShu':
      return fundZhiShu;
    case 'fundGuPiao':
      return fundGuPiao;
    case 'fundQdii':
      return fundQdii;
    case 'fundStabe':
      return fundStabe;
    case 'fundList1':
      return fundList1;
    case 'fundTaoli':
      return fundTaoli;
    default:
      return null;
  }
});

// 格式化时间
const formattedTime = computed(() => {
  const date = new Date(sharedData.message);
  return date.toLocaleString(); // 使用默认的本地化格式
});

// 持久化选中的 Tab
watch(currentTab, (newValue) => {
  // 当 currentTab 改变时，保存到 localStorage
  localStorage.setItem('currentTab', newValue);
});
// 页面加载时，从 localStorage 中读取上次选中的 Tab
const savedTab = localStorage.getItem('currentTab');
if (savedTab) {
  currentTab.value = savedTab;
}
</script>

<style scoped>
/* 在 App.vue 中设置全局样式 */
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* 设置表格单元格的字体大小 */
.el-table td,
.el-table th {
  font-size: 12px; /* 可以根据需要调整字体大小 */
}


</style>